import type { AgentObj } from "@/types/interfaces/agents";

export function getMonths(dateString: string): number {
  const inputDate = new Date(dateString);
  if (isNaN(inputDate.getTime())) {
    return 0;
  }
  // Counts calendar months crossed, ignoring the day of the month (Oct 15 -> Nov 2 is 1)
  inputDate.setDate(1);
  const today = new Date();
  const yearsDifference = today.getFullYear() - inputDate.getFullYear();
  const monthsDifference = today.getMonth() - inputDate.getMonth();
  return yearsDifference * 12 + monthsDifference;
}

// Helper function for status-based coloring
export const getStatusColor = (data?: AgentObj): "danger" | "success" | "warning" | "primary" => {
  if (data?.secretAgent) return "danger";
  if (data?.status === "NEW") return "success";
  if (data?.status === "LEAVING") return "warning";
  return "primary";
};

// North American numbers as (416) 562-9158; anything else (extensions, notes, overseas) as typed. "+1" alone is empty
export const formatPhone = (value?: string | null): string => {
  if (!value) return "-";
  const digits = value.replace(/\D/g, "");
  if (digits.length <= 1) return "-";
  const local = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (local.length !== 10 || /[a-z]/i.test(value)) return value;
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
};
